/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsProjectResponse extends models.AppSecopsProject {
    getFixupPrototypeFunction() { return AppSecopsProjectResponse.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsProjectResponse>): AppSecopsProjectResponse {
        let obj = Object.assign(new AppSecopsProjectResponse(), model);
        AppSecopsProjectResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsProjectResponse>): AppSecopsProjectResponse {
        if (!model) return null;
        return AppSecopsProjectResponse.newInstance(<AppSecopsProjectResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsProjectResponse) {
        if (!obj) return;

        models.AppSecopsProjectResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsProjectResponse): boolean {
        if (models.AppSecopsProject.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsProjectResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
